/**
 * GET `admin/audit` — журнал аудита платформенной зоны (ADMIN_SPEC §3.9).
 * Cursor-пагинация: ответ несёт nextCursor (null — лента кончилась).
 * Gateway говорит camelCase — конверсию кейсов глушим. Без BE — мок.
 */

import {apiEnabled, http} from '@services/utils';

import {mockAuditPage} from '../mocks';
import type {AuditEntry, AuditPage, GetAuditRequest} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

type Raw = Record<string, unknown>;

const asObj = (v: unknown): Raw | null => (typeof v === 'object' && v !== null ? (v as Raw) : null);
const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');

const toEntry = (v: unknown): AuditEntry | null => {
  const r = asObj(v);
  if (r === null) return null;
  return {
    id: asStr(r.id),
    actorLogin: typeof r.actorLogin === 'string' && r.actorLogin !== '' ? r.actorLogin : '—',
    action: asStr(r.action),
    entityType: asStr(r.entityType),
    entityId: typeof r.entityId === 'string' ? r.entityId : null,
    payload: asObj(r.payload),
    createdAt: asStr(r.createdAt),
  };
};

export const getAudit = async (req: GetAuditRequest): Promise<AuditPage> => {
  if (!apiEnabled) {
    await sleep(260);
    return mockAuditPage(req);
  }

  const raw = await http<Raw>('admin/audit', {
    params: {
      ...(req.from !== undefined && {from: req.from}),
      ...(req.cursor !== undefined && {cursor: req.cursor}),
      limit: String(req.limit ?? 20),
    },
    skipCaseConversion: true,
  });
  return {
    items: (Array.isArray(raw.items) ? raw.items : [])
      .map(toEntry)
      .filter((e): e is AuditEntry => e !== null),
    nextCursor: typeof raw.nextCursor === 'string' ? raw.nextCursor : null,
  };
};
